import { render, staticRenderFns } from "./tvaForm.vue?vue&type=template&id=043e8eab&"
import script from "./tvaForm.vue?vue&type=script&lang=js&"
export * from "./tvaForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports